import {Card, CardBody, Row, Col} from "reactstrap";
import {RingLoader} from "react-spinners";

const Loading = () => (
  <Row>
    <Col lg="12" md="12">
      <Card>
        <CardBody>
          <div className="dropbox default">
            <div className="iconWrapper">
              <RingLoader color="#4682b4" size={80} loading={true} />
            </div>
            <p className="statusMessage">Authenticating</p>
          </div>
        </CardBody>
      </Card>
    </Col>
  </Row>
);

export default Loading;
